import React, { useCallback, useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { parsePhoneNumberFromString } from 'libphonenumber-js'

interface PhoneNumberInputProps {
  setPhoneNumber: React.Dispatch<React.SetStateAction<string | undefined>>
  setCountryPhoneCode: React.Dispatch<React.SetStateAction<string | undefined>>
}

export function PhoneNumberInput({
  setPhoneNumber,
  setCountryPhoneCode,
}: Readonly<PhoneNumberInputProps>) {
  const [phone, setPhone] = useState<string>('')
  const [countryCode, setCountryCode] = useState<string>('my')

  const handlePhoneChange = useCallback(
    (value: string, data: any) => {
      setPhone(value)
      setCountryPhoneCode(data.dialCode)
      setCountryCode(data.countryCode)

      parsePhoneNumberFromString(value || '', data.countryCode?.toUpperCase())
      console.log('====================================')
      console.log({ country: data })
      console.log('====================================')
      const rawNumber = value.replace(data.dialCode, '')
      const cleanedNumber = rawNumber.replace(/^0+/, '')
      setPhoneNumber(cleanedNumber)
    },
    [setPhoneNumber, setCountryPhoneCode],
  )

  return (
    <div style={styles.container}>
      <PhoneInput
        country={countryCode}
        value={phone}
        onChange={handlePhoneChange}
        inputStyle={styles.input}
        buttonStyle={styles.flagButton}
        enableSearch
        disableSearchIcon={false}
        inputProps={{
          name: 'phone',
          required: true,
          autoFocus: false,
        }}
      />
    </div>
  )
}

const styles = {
  container: {
    width: '100%',
    margin: '8px 0',
    display: 'flex',
    justifyContent: 'center',
  },
  input: {
    width: '100%',
    height: '40px',
    fontSize: '16px',
    borderRadius: '4px',
  },
  flagButton: {
    borderRadius: '4px 0 0 4px',
  },
}
